import { IState } from '../IState';

const targetsStoreSelector = (state: IState) => state.targets;

// TARGETS
const targetsStoreTargetsSelector = (state: IState) => targetsStoreSelector(state).targets;
const projectsStoreProjectsDataSelector = (state: IState) => targetsStoreTargetsSelector(state).data;
const projectsStoreProjectsMetaSelector = (state: IState) => targetsStoreTargetsSelector(state).meta;

export const targetsListSelector = (state: IState) => projectsStoreProjectsDataSelector(state).list;
export const targetsListNetworkStatusSelector = (state: IState) => projectsStoreProjectsMetaSelector(state).networkStatus;

// TARGET
const targetsStoreTargetSelector = (state: IState) => targetsStoreSelector(state).target;
const targetsStoreTargetDataSelector = (state: IState) => targetsStoreTargetSelector(state).data;
const targetsStoreTargetMetaSelector = (state: IState) => targetsStoreTargetSelector(state).meta;

export const targetsItemSelector = (state: IState) => targetsStoreTargetDataSelector(state).target;
export const targetsItemPlanSelector = (state: IState) => targetsStoreTargetDataSelector(state).plan;
export const targetsItemNetworkStatusSelector = (state: IState) => targetsStoreTargetMetaSelector(state).networkStatus;

// CURRENT TARGET
const targetsStoreCurrentTargetSelector = (state: IState) => targetsStoreSelector(state).currentTarget;
const targetsStoreCurrentTargetDataSelector = (state: IState) => targetsStoreCurrentTargetSelector(state).data;
const targetsStoreCurrentTargetMetaSelector = (state: IState) => targetsStoreCurrentTargetSelector(state).meta;

export const targetsCurrentSelector = (state: IState) => targetsStoreCurrentTargetDataSelector(state).target;
export const targetsCurrentPlanSelector = (state: IState) => targetsStoreCurrentTargetDataSelector(state).plan;
export const targetsCurrentNetworkStatusSelector = (state: IState) => targetsStoreCurrentTargetMetaSelector(state).networkStatus;
